import { string } from 'yup';

export const passwordSchema = string()
  .typeError('A senha precisa ser um campo de texto')
  .required('Informe uma senha')
  .min(8, 'A senha deve ter no mínimo 8 caracteres')
  .max(36, 'A senha deve ter no máximo 36 caracteres')
  .matches(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula')
  .matches(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula')
  .matches(/\d/, 'A senha deve conter pelo menos um número')
  .matches(
    /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/,
    'A senha deve conter pelo menos um caractere especial',
  );

export const loginPasswordSchema = string()
  .typeError('A senha precisa ser um campo de texto')
  .required('Informe uma senha')
  .max(255, 'Credenciais inválidas');

export const currentPasswordSchema = string()
  .typeError('A senha precisa ser um campo de texto')
  .required('Informe a senha atual')
  .max(255, 'Senha atual inválida');
